import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DataCacheService from '@/shared/services/DataCacheService';

class UserName extends PureComponent {
  render() {
    const { userId, ...rest } = this.props;
    if (!userId) return null;
    return <span {...rest}>{DataCacheService.getUserName(userId)}</span>;
  }
}

UserName.propTypes = {
  userId: PropTypes.string,
};
UserName.defaultProps = {
  userId: undefined,
};

export default UserName;
